// Generated by ts-to-zod
import { z } from 'zod';
import { engineUseCaseSchema } from '../../engines/models/engine.schema';

export const listPreTrainedFieldsQuerySchema = z.object({
  engineUseCase: engineUseCaseSchema.optional(),
});
